export enum Navigation {
    HOME = 'HOME',
    RULES = 'RULES',
    JURY = 'JURY',
    FORM = 'FORM',
    NEWS = 'NEWS',
    WINNERS = 'WINNERS',
    VOTING = 'VOTING'
}
